import React from 'react'
const withAccordionControl = (WrappedComponent, variant = 'single') => {
  return class withAccordionControl extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        collapsed: true, // single
        currentOpened: null, // multiple
      }
      this.toggle = this.toggle.bind(this)
    }

    toggle(key = '') {
      if (variant === 'single') {
        this.setState((state) => ({ collapsed: !state.collapsed }))
      } else {
        this.setState((state) => ({ currentOpened: state.currentOpened !== key ? key : null }))
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          accordionCollapsed={this.state.collapsed}
          accordionOpened={this.state.currentOpened}
          accordionToggle={this.toggle}
        />
      )
    }
  }
}

export default withAccordionControl
